import { createSelector } from 'reselect'

import { selectPartner360Data } from './selectPartner360Data'
import { selectProgramType } from './selectProgramType'

export const selectP360Profile = createSelector(
  [selectPartner360Data, selectProgramType],
  ({ p360Profiles }, programType) => {
    return p360Profiles.find((it) => it.Offering === programType)
  }
)
